import { lazy, Suspense } from 'react';

/**
 * PMTiles 検査ツール の React.lazy wrapper (AW10、docs/108 Critical #15)。
 *
 * user app の `MapView` / `MapViewImpl` 分離と同じ理由:
 *   実装本体 (`MapPmtilesInspectorPageImpl.tsx`) は maplibre-gl + pmtiles + maplibre-gl CSS
 *   (~700-900KB) を import するため、本 wrapper で dynamic import 化して main chunk から切り離す。
 *
 * 副次効果 (重要): districts-admin barrel (`index.ts`) 経由でこの module を import しても
 *   maplibre-gl が eager に評価されない。jsdom test 環境では maplibre-gl の top-level
 *   `window.URL.createObjectURL` 参照が throw するため、eager import すると barrel を読む
 *   全 admin test が落ちる。lazy 化でこれを回避する。
 */

const LazyInspector = lazy(() => import('./MapPmtilesInspectorPageImpl'));

function InspectorFallback() {
  return (
    <div className="flex items-center justify-center py-12">
      <div
        className="w-8 h-8 border-2 border-slate-300 border-t-primary-600 rounded-full animate-spin"
        role="status"
        aria-label="検査ツールを読み込み中"
      />
    </div>
  );
}

export function MapPmtilesInspectorPage() {
  return (
    <Suspense fallback={<InspectorFallback />}>
      <LazyInspector />
    </Suspense>
  );
}
